import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Badge, Tooltip } from '@mui/material';
import IconButton from 'components/@extended/IconButton';
import Basket from 'assets/header-icons/Basket';
import { api } from "@/api/axios";

// Context
import { useAuth } from '@/auth/AuthContext';

export default function BasketIcon() {
  const navigate = useNavigate();
  const location = useLocation();
  const [count, setCount] = useState(0);
  const { totalQuantity } = useAuth();

  useEffect(() => {
    if (totalQuantity !== undefined && totalQuantity !== null) {
      setCount(totalQuantity);
    }
  }, [totalQuantity]);

  useEffect(() => {
    const fetchTotal = async () => {
      try {
        const response = await api.post('/gates/data/get_basket_total_quantity', {});
        const data = response.data;
        if (data.SUCCESS === true) {
          setCount(data.DATA.TOTAL || 0);
        } else {
          console.error('Ошибка получения количества корзины:', data?.ERROR?.MESSAGE);
        }
      } catch (error) {
        console.error('Ошибка запроса get_basket_total_quantity:', error);
      }
    };

    fetchTotal();
  }, [location.pathname]);

  const handleClick = () => {
    navigate('/basket');
  };

  return (
    <Tooltip title="Корзина">
      <IconButton
        color="secondary"
        sx={{
            color: 'text.primary',
            bgcolor: 'transparent',
            '&:hover': {
              bgcolor: 'grey.100',
            },
            '&:active': {
              bgcolor: 'grey.100',
            },
            '&.Mui-focusVisible': {
              bgcolor: 'transparent',
            },
          }}
        onClick={handleClick}
      >
        <Badge badgeContent={count} color="primary" showZero={false}>
          <Basket width={20} height={20} />
        </Badge>
      </IconButton>
    </Tooltip>
  );
}